// extracted by mini-css-extract-plugin
module.exports = {"deleteArea":"edit-area_deleteArea__H1Cp-"};